import React from "react";
import {Col, Row} from "antd";
import { template, setLocalStorage, transformAssetsUrl } from "@reco-m/core";
import { ViewComponent, Banner, ImageAuto, Loading, HtmlContent } from "@reco-w/core-ui";
import { Namespaces, classiccaseModel } from "@reco-w/classiccase-models";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Navigation, Pagination, EffectCoverflow } from "swiper";
import { BackTopBox } from "@reco-w/about-e";
import { EnumGroupHomeTag, r2040ArticleService } from "@reco-w/common-common";
SwiperCore.use([Autoplay, Navigation, Pagination, EffectCoverflow]);


const clientData = [
    {
        "AppID": 925078493593699,
        "BindTableName": "STDArticle",
        "CatalogName": "综合开发区",
        "CatalogCode": "zonghkfq",
        "ParentID": 2341234286788805,
        "Layer": 2,
        "Path": ",0,2,2341234286788805,",
        "Sequence": 1,
        "IsValid": true,
        "IsDelete": false,
        "Inputer": "系统管理员",
        "InputerID": 1,
        "InputTime": "2020-06-03T11:27:27.77",
        "ID": 2341234437783749,
        "chileList": [
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399471006646336,
                "Title": "漕河泾开发区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:40:17.367",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:43:20.49",
                "Sequence": 10,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399471308636216,
                "Title": "临港新片区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:40:35.61",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:43:24.557",
                "Sequence": 20,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399472080388169,
                "Title": "上海金桥经开区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:41:21.997",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:43:25.7",
                "Sequence": 30,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399472818585798,
                "Title": "上海自贸区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:42:05.347",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:43:26.467",
                "Sequence": 40,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399473489674494,
                "Title": "外高桥保税区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:42:45.847",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:43:27.313",
                "Sequence": 50,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399473741332593,
                "Title": "上海世博开发区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:43:00.003",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:43:28.047",
                "Sequence": 60,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399474009768172,
                "Title": "宜秀经济开发区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:43:16.76",
                "Sequence": 70,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399474546639101,
                "Title": "南京经开区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:43:48.753",
                "Sequence": 80,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399474764742761,
                "Title": "武汉经开区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:44:01.203",
                "Sequence": 90,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399475066732650,
                "Title": "北京未来科学城",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:44:19.737",
                "Sequence": 100,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399475234504814,
                "Title": "定州经开区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:44:29.117",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:06.45",
                "Sequence": 110,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399475469385851,
                "Title": "临港海洋高新区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:44:43.303",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:12.12",
                "Sequence": 120,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399475586826345,
                "Title": "合肥国家高新区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:44:50.377",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:19.567",
                "Sequence": 130,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399475737821330,
                "Title": "贵阳国家高新区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:44:59.183",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:21.91",
                "Sequence": 140,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399475855261764,
                "Title": "海口国家高新区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:45:06.97",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:26.77",
                "Sequence": 150,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399475989479664,
                "Title": "安庆筑梦新区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:45:14.723",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:31.93",
                "Sequence": 160,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399476140474514,
                "Title": "马鞍山郑蒲港新区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:45:23.267",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:34.02",
                "Sequence": 170,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399476257915073,
                "Title": "三门峡高新区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:45:30.79",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:39.357",
                "Sequence": 180,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399476408910017,
                "Title": "贵阳综合保税区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:45:39.427",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:47:32.127",
                "Sequence": 190,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399476694122690,
                "Title": "大庆高新区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:45:56.763",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:41.917",
                "Sequence": 200,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399476845117640,
                "Title": "上海迪士尼乐园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:46:05.797",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:43.783",
                "Sequence": 210,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399476979335339,
                "Title": "上海长兴岛",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:46:13.093",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:45.757",
                "Sequence": 220,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399477079998542,
                "Title": "盘锦高新区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:46:19.843",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:49.097",
                "Sequence": 230,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399477264547986,
                "Title": "中宁工业园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:46:30.28",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:51.427",
                "Sequence": 240,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399477381988549,
                "Title": "广州高新技术产业开发区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:46:37.943",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:53.507",
                "Sequence": 250,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399477516206144,
                "Title": "广州民营科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:46:45.06",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:56.277",
                "Sequence": 260,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399477667201264,
                "Title": "......",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:46:54.89",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:59.93",
                "Sequence": 500,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            }
        ],
        "ImgUrl": "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/Assets/Images/nopic.jpg"
    },
    {
        "AppID": 925078493593699,
        "BindTableName": "STDArticle",
        "CatalogName": "高新技术产业园",
        "CatalogCode": "gaoxjscyy",
        "ParentID": 2341234286788805,
        "Layer": 2,
        "Path": ",0,2,2341234286788805,",
        "Sequence": 2,
        "IsValid": true,
        "IsDelete": false,
        "Inputer": "系统管理员",
        "InputerID": 1,
        "InputTime": "2020-06-03T11:27:46.14",
        "ID": 2341234756550733,
        "chileList": [
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399480385110065,
                "Title": "张江高科",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:49:36.447",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:53:45.543",
                "Sequence": 10,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399480519327765,
                "Title": "中关村昌平园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:49:44.19",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:53:46.597",
                "Sequence": 20,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399481190416405,
                "Title": "临港松江科技城",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:50:24.317",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:53:48.117",
                "Sequence": 30,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399481307857030,
                "Title": "上海临空经济园区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:50:31.85",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:53:49.217",
                "Sequence": 40,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399481425297598,
                "Title": "临港海立方科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:50:38.753",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:53:55.13",
                "Sequence": 50,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399481525960838,
                "Title": "上海银行卡产业园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:50:44.287",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:53:56.717",
                "Sequence": 60,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399481643401345,
                "Title": "上海徐汇软件园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:50:51.94",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:53:58.257",
                "Sequence": 70,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399481760841746,
                "Title": "广州荔湾海龙科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:50:58.27",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:53:59.31",
                "Sequence": 80,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399481861505115,
                "Title": "上海临港软件园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:51:04.927",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:00.737",
                "Sequence": 90,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399481962168334,
                "Title": "南京智能制造产业园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:51:10.983",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:02.26",
                "Sequence": 100,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399482213826614,
                "Title": "嘉兴科技城",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:51:25.093",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:03.707",
                "Sequence": 110,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399482364821680,
                "Title": "牡丹智慧园（牡丹集团）",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:51:34.74",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:05.927",
                "Sequence": 120,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399482482262181,
                "Title": "北京新元科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:51:41.72",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:06.917",
                "Sequence": 130,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399482599702584,
                "Title": "北京房山互联网金融产业园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:51:48.287",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:08.923",
                "Sequence": 140,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399482683588643,
                "Title": "北京光机电一体化产业园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:51:53.73",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:10.43",
                "Sequence": 150,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399483069464590,
                "Title": "张江集电港",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:52:16.11",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:19.553",
                "Sequence": 180,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399483153350748,
                "Title": "上海周浦智慧产业园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:52:21.783",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:21.15",
                "Sequence": 190,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399483304345682,
                "Title": "中国传感网国际创新园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:52:30.267",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:22.147",
                "Sequence": 200,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399483455340580,
                "Title": "国信安基地",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:52:39.26",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:23.653",
                "Sequence": 210,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399483589558364,
                "Title": "上海唐镇电子商务创新港",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:52:47.187",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:24.76",
                "Sequence": 220,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399483690221604,
                "Title": "无锡（国家）软件园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:52:53.383",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:25.897",
                "Sequence": 230,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399483790884882,
                "Title": "中新仁恒海门长江生态科技城",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:52:59.72",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:27.28",
                "Sequence": 240,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399483908325594,
                "Title": "中国出版蓝桥创意产业园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:53:06.06",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:28.747",
                "Sequence": 250,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399484008988743,
                "Title": "移动智地",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:53:12.267",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:29.997",
                "Sequence": 260,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399484109652139,
                "Title": "江苏虚拟软件园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:53:18.953",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:32.13",
                "Sequence": 270,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399484277424311,
                "Title": "......",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:53:28.553",
                "Sequence": 500,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            }
        ],
        "ImgUrl": "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/Assets/Images/nopic.jpg"
    },
    {
        "AppID": 925078493593699,
        "BindTableName": "STDArticle",
        "CatalogName": "大学科技园",
        "CatalogCode": "daxkjy",
        "ParentID": 2341234286788805,
        "Layer": 2,
        "Path": ",0,2,2341234286788805,",
        "Sequence": 3,
        "IsValid": true,
        "IsDelete": false,
        "Inputer": "系统管理员",
        "InputerID": 1,
        "InputTime": "2020-06-03T11:27:54.073",
        "ID": 2341234890768559,
        "chileList": [
            {
                "ProjectContent": "",
                "ID": 2344373572337831,
                "Title": "北京大学科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:25:54.693",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:57.923",
                "Sequence": 10,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>&nbsp;</p>"
                },
                "ContentTEXT": " ",
                "ImgUrls": [],
                "CatalogueName": "大学科技园",
                "CatalogueID": 2341234890768559,
                "CommentNum": 0
            },
            {
                "ProjectContent": "",
                "ID": 2344373874327619,
                "Title": "清华大学科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:26:12.997",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:58.893",
                "Sequence": 20,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>&nbsp;</p>"
                },
                "ContentTEXT": " ",
                "ImgUrls": [],
                "CatalogueName": "大学科技园",
                "CatalogueID": 2341234890768559,
                "CommentNum": 0
            },
            {
                "ProjectContent": "",
                "ID": 2344374075654311,
                "Title": "浙江大学科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:26:24.63",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:55:00.433",
                "Sequence": 30,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>&nbsp;</p>"
                },
                "ContentTEXT": " ",
                "ImgUrls": [],
                "CatalogueName": "大学科技园",
                "CatalogueID": 2341234890768559,
                "CommentNum": 0
            },
            {
                "ProjectContent": "",
                "ID": 2344374260203773,
                "Title": "同济大学科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:26:35.237",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:55:02.17",
                "Sequence": 40,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>&nbsp;</p>"
                },
                "ContentTEXT": " ",
                "ImgUrls": [],
                "CatalogueName": "大学科技园",
                "CatalogueID": 2341234890768559,
                "CommentNum": 0
            },
            {
                "ProjectContent": "",
                "ID": 2344374444752928,
                "Title": "上海交通大学科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:26:46.79",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:55:04.26",
                "Sequence": 50,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>&nbsp;</p>"
                },
                "ContentTEXT": " ",
                "ImgUrls": [],
                "CatalogueName": "大学科技园",
                "CatalogueID": 2341234890768559,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399486072586331,
                "Title": "上海理工大学科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:55:15.33",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:56:25.49",
                "Sequence": 60,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "大学科技园",
                "CatalogueID": 2341234890768559,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399486324244529,
                "Title": "西安交大国家大学科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:55:30.243",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:56:26.527",
                "Sequence": 70,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "大学科技园",
                "CatalogueID": 2341234890768559,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399486391353565,
                "Title": "北京农学院科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:55:34.227",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:56:27.577",
                "Sequence": 80,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "大学科技园",
                "CatalogueID": 2341234890768559,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399486508793920,
                "Title": "长兴国家大学科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:55:41.29",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:56:28.703",
                "Sequence": 90,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "大学科技园",
                "CatalogueID": 2341234890768559,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399486609457373,
                "Title": "洛阳国家大学科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:55:47.43",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:56:30.22",
                "Sequence": 100,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "大学科技园",
                "CatalogueID": 2341234890768559,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399486726897713,
                "Title": "上海体育学院科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:55:54.323",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:56:31.457",
                "Sequence": 110,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "大学科技园",
                "CatalogueID": 2341234890768559,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399486827561051,
                "Title": "保定国家大学科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:56:00.983",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:56:34.367",
                "Sequence": 120,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "大学科技园",
                "CatalogueID": 2341234890768559,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399486995333169,
                "Title": "......",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:56:10.293",
                "Sequence": 500,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "大学科技园",
                "CatalogueID": 2341234890768559,
                "CommentNum": 0
            }
        ],
        "ImgUrl": "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/Assets/Images/nopic.jpg"
    },
    {
        "AppID": 925078493593699,
        "BindTableName": "STDArticle",
        "CatalogName": "生物医药产业园",
        "CatalogCode": "shengwyycyy",
        "ParentID": 2341234286788805,
        "Layer": 2,
        "Path": ",0,2,2341234286788805,",
        "Sequence": 4,
        "IsValid": true,
        "IsDelete": false,
        "Inputer": "系统管理员",
        "InputerID": 1,
        "InputTime": "2020-06-03T11:28:07.147",
        "ID": 2341235108872389,
        "chileList": [
            {
                "ProjectContent": "",
                "ID": 2344374931292234,
                "Title": "张江生物医药基地（张江药谷）",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:27:15.437",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-30T15:54:19.5",
                "Sequence": 10,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>&nbsp;</p>"
                },
                "ContentTEXT": " ",
                "ImgUrls": [],
                "CatalogueName": "生物医药产业园",
                "CatalogueID": 2341235108872389,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2344375132618869,
                "Title": "北京中关村生命科学园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:27:27.123",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-30T15:55:31.85",
                "Sequence": 20,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>&nbsp;</p>"
                },
                "ContentTEXT": " ",
                "ImgUrls": [],
                "CatalogueName": "生物医药产业园",
                "CatalogueID": 2341235108872389,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2424128900431897,
                "Title": "上海国际医学园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-30T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-30T15:55:42.243",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-30T15:55:47.24",
                "Sequence": 30,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "生物医药产业园",
                "CatalogueID": 2341235108872389,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2344375333945587,
                "Title": "北京大兴生物医药产业基地",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:27:39.083",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-06-30T14:55:08.49",
                "Sequence": 40,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>&nbsp;</p>"
                },
                "ContentTEXT": " ",
                "ImgUrls": [],
                "CatalogueName": "生物医药产业园",
                "CatalogueID": 2341235108872389,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2424129470857389,
                "Title": "上海张江药谷公共服务平台",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-30T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-30T15:56:16.653",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-30T15:57:23.623",
                "Sequence": 50,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "生物医药产业园",
                "CatalogueID": 2341235108872389,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2424129605074981,
                "Title": "上海市生物医药促进中心",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-30T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-30T15:56:24.447",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-30T15:57:32.907",
                "Sequence": 60,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "生物医药产业园",
                "CatalogueID": 2341235108872389,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2344375518494914,
                "Title": "江苏无锡惠山生命科技产业园区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:27:50.66",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-30T15:58:12.563",
                "Sequence": 70,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>&nbsp;</p>"
                },
                "ContentTEXT": " ",
                "ImgUrls": [],
                "CatalogueName": "生物医药产业园",
                "CatalogueID": 2341235108872389,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2424130091614381,
                "Title": "上海金山区生物医药产业基地",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-30T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-30T15:56:53.733",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-30T15:57:37.63",
                "Sequence": 80,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "生物医药产业园",
                "CatalogueID": 2341235108872389,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2344374696411212,
                "Title": "上海维亚生物国际孵化基地",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:27:01.577",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-30T15:54:30.96",
                "Sequence": 90,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>&nbsp;</p>"
                },
                "ContentTEXT": " ",
                "ImgUrls": [],
                "CatalogueName": "生物医药产业园",
                "CatalogueID": 2341235108872389,
                "CommentNum": 0
            },
            {
                "ProjectContent": "",
                "ID": 2344375921147934,
                "Title": "……",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:28:14.7",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:56:57.387",
                "Sequence": 500,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>&nbsp;</p>"
                },
                "ContentTEXT": " ",
                "ImgUrls": [],
                "CatalogueName": "生物医药产业园",
                "CatalogueID": 2341235108872389,
                "CommentNum": 0
            }
        ],
        "ImgUrl": "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/Assets/Images/nopic.jpg"
    },
    {
        "AppID": 925078493593699,
        "BindTableName": "STDArticle",
        "CatalogName": "孵化众创",
        "CatalogCode": "fuhq/zckj",
        "ParentID": 2341234286788805,
        "Layer": 2,
        "Path": ",0,2,2341234286788805,",
        "Sequence": 5,
        "IsValid": true,
        "IsDelete": false,
        "Inputer": "系统管理员",
        "InputerID": 1,
        "InputTime": "2020-06-03T11:28:19.76",
        "ID": 2341235310198981,
        "chileList": [
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399488773718152,
                "Title": "杨浦科创",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:57:56.95",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:26.517",
                "Sequence": 10,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399488874381403,
                "Title": "中关村e谷",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:58:02.96",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:27.677",
                "Sequence": 20,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399489008599176,
                "Title": "上海交大慧谷科创中心",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:58:10.34",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:29.197",
                "Sequence": 30,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399489126039708,
                "Title": "康佳之星",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:58:17.023",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:30.133",
                "Sequence": 40,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399489226703095,
                "Title": "阿里云创新中心",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:58:23.983",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:31.24",
                "Sequence": 50,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399489344143480,
                "Title": "麦腾众创",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:58:30.093",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:32.493",
                "Sequence": 60,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399489495138382,
                "Title": "漕河泾创业中心",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:58:39.787",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:33.527",
                "Sequence": 70,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399489813905464,
                "Title": "张江孵化器",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:58:58.027",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:38.407",
                "Sequence": 90,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399489948123214,
                "Title": "上海虹口区科创中心",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:59:06.147",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:39.74",
                "Sequence": 100,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399490132672576,
                "Title": "上海奉贤区科创中心",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:59:17.203",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:40.857",
                "Sequence": 110,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399490233336029,
                "Title": "同济大学科技园创业中心",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:59:23.67",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:43.867",
                "Sequence": 120,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399490367553776,
                "Title": "同济大学科技园国康路创业基地",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:59:31.41",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:45.29",
                "Sequence": 130,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399490518548701,
                "Title": "同济嘉定科技创业园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:59:40.81",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:49.86",
                "Sequence": 140,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399490635989112,
                "Title": "复旦大学科技园创业中心",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:59:47.517",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:51.717",
                "Sequence": 150,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399490786984096,
                "Title": "上海交大金桥科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:59:56.93",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:54.53",
                "Sequence": 160,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399490904424484,
                "Title": "上海交大嘉兴科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:00:03.707",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:55.973",
                "Sequence": 170,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399491021865129,
                "Title": "上海环保科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:00:10.073",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:57.517",
                "Sequence": 180,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399491172860125,
                "Title": "上海慧谷白猫科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:00:19.16",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:59.33",
                "Sequence": 190,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399491256746104,
                "Title": "上海上生慧谷生物科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:00:24.933",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:02.81",
                "Sequence": 200,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399491357409495,
                "Title": "上海新慧谷科技产业园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:00:30.993",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:04.413",
                "Sequence": 210,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399491458072745,
                "Title": "上海慧山科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:00:36.697",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:16.22",
                "Sequence": 220,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399491575513198,
                "Title": "北航先进技术产业基地（佛山）",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:00:43.63",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:17.767",
                "Sequence": 230,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399491692953628,
                "Title": "上海市科创-闵行加速器",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:00:50.423",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:19.363",
                "Sequence": 240,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399491793616897,
                "Title": "上海集成电路创业孵化基地",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:00:56.657",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:20.53",
                "Sequence": 250,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399491894280361,
                "Title": "张江移动互联网孵化器",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:01:02.74",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:21.66",
                "Sequence": 260,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399492028497998,
                "Title": "上海黄浦区科创中心",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:01:10.187",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:22.987",
                "Sequence": 270,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399492162715758,
                "Title": "江苏武进科创中心",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:01:18.637",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:24.34",
                "Sequence": 280,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399492313710827,
                "Title": "江苏常州湖塘科创园\t",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:01:27.313",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:26.593",
                "Sequence": 290,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399492414374141,
                "Title": "创业谷•光华",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:01:33.737",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:28.5",
                "Sequence": 300,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399492548591869,
                "Title": "清控科创-北京双创街",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:01:41.127",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:34.127",
                "Sequence": 310,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399492666032297,
                "Title": "袍江科创中心",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:01:48.46",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:35.387",
                "Sequence": 320,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399492783472809,
                "Title": "北京禾芫科技孵化器",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:01:55.823",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:36.48",
                "Sequence": 330,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399492900913180,
                "Title": "北京赛欧孵化器",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:02:02.363",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:37.677",
                "Sequence": 340,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399493018353900,
                "Title": "意谷时代科技孵化器",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:02:09.763",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:39.117",
                "Sequence": 350,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399493135794430,
                "Title": "......",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:02:16.71",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:44.237",
                "Sequence": 500,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            }
        ],
        "ImgUrl": "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/Assets/Images/nopic.jpg"
    },
    {
        "AppID": 925078493593699,
        "BindTableName": "STDArticle",
        "CatalogName": "产业地产",
        "CatalogCode": "kaifjt/cydc",
        "ParentID": 2341234286788805,
        "Layer": 2,
        "Path": ",0,2,2341234286788805,",
        "Sequence": 6,
        "IsValid": true,
        "IsDelete": false,
        "Inputer": "系统管理员",
        "InputerID": 1,
        "InputTime": "2020-06-03T11:28:38.99",
        "ID": 2341235628966085,
        "chileList": [
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399495836925959,
                "Title": "临港集团",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:04:57.027",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:49.407",
                "Sequence": 10,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "产业地产",
                "CatalogueID": 2341235628966085,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399495937589318,
                "Title": "招商蛇口",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:05:03.003",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:50.363",
                "Sequence": 20,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "产业地产",
                "CatalogueID": 2341235628966085,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399496021475421,
                "Title": "启迪协信集团",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:05:08.953",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:52.037",
                "Sequence": 30,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "产业地产",
                "CatalogueID": 2341235628966085,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399496122138631,
                "Title": "张江集团",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:05:14.7",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:52.867",
                "Sequence": 40,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "产业地产",
                "CatalogueID": 2341235628966085,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399496222801990,
                "Title": "外高桥集团",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:05:20.707",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:53.83",
                "Sequence": 50,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "产业地产",
                "CatalogueID": 2341235628966085,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399496340242651,
                "Title": "上汽集团",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:05:27.053",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:55.107",
                "Sequence": 60,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "产业地产",
                "CatalogueID": 2341235628966085,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399496440905926,
                "Title": "中国文化产业发展集团",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:05:33.043",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:56.34",
                "Sequence": 70,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "产业地产",
                "CatalogueID": 2341235628966085,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399496558346330,
                "Title": "上海静工（集团）",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:05:40.553",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:57.847",
                "Sequence": 80,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "产业地产",
                "CatalogueID": 2341235628966085,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399496642232410,
                "Title": "新加坡仁恒置地集团",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:05:45.857",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:09:01.527",
                "Sequence": 90,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "产业地产",
                "CatalogueID": 2341235628966085,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399496726118649,
                "Title": "上海宝华企业集团",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:05:50.89",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:09:02.803",
                "Sequence": 100,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "产业地产",
                "CatalogueID": 2341235628966085,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399496826781907,
                "Title": "华鑫置业（集团）",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:05:56.773",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:09:07.517",
                "Sequence": 110,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "产业地产",
                "CatalogueID": 2341235628966085,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399496927444999,
                "Title": "华润置地（华东大区）",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:06:02.68",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:09:12.243",
                "Sequence": 120,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "产业地产",
                "CatalogueID": 2341235628966085,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399497028108522,
                "Title": "保福科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:06:08.48",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:09:13.763",
                "Sequence": 130,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "产业地产",
                "CatalogueID": 2341235628966085,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399497145548927,
                "Title": "......",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:06:15.177",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:09:18.097",
                "Sequence": 500,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "产业地产",
                "CatalogueID": 2341235628966085,
                "CommentNum": 0
            }
        ],
        "ImgUrl": "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/Assets/Images/nopic.jpg"
    },
    {
        "AppID": 925078493593699,
        "BindTableName": "STDArticle",
        "CatalogName": "政府",
        "CatalogCode": "zhengf",
        "ParentID": 2341234286788805,
        "Layer": 2,
        "Path": ",0,2,2341234286788805,",
        "Sequence": 7,
        "IsValid": true,
        "IsDelete": false,
        "Inputer": "系统管理员",
        "InputerID": 1,
        "InputTime": "2020-06-03T11:28:46.963",
        "ID": 2341235763183813,
        "chileList": [
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399497531424969,
                "Title": "北京天竺镇政府",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:06:38.823",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:17.313",
                "Sequence": 10,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399497632088191,
                "Title": "上海市委组织部",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:06:44.813",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:19.083",
                "Sequence": 20,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399497749528646,
                "Title": "天津津南区政府",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:06:51.033",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:20.433",
                "Sequence": 30,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399497833414754,
                "Title": "合肥市委组织部",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:06:56.363",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:21.63",
                "Sequence": 40,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399497934078180,
                "Title": "杭州市委组织部",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:07:02.517",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:22.743",
                "Sequence": 50,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399498034741485,
                "Title": "晋中市政府",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:07:08.44",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:24.153",
                "Sequence": 60,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399498118627398,
                "Title": "贵阳市委组织部",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:07:13.833",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:25.093",
                "Sequence": 70,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399498219290852,
                "Title": "川沙新镇政府",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:07:19.083",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:26.453",
                "Sequence": 80,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399498336731234,
                "Title": "北蔡镇政府",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:07:26.01",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:28.157",
                "Sequence": 90,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399498420617444,
                "Title": "浦东新区区委组织部",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:07:31.597",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:32.07",
                "Sequence": 100,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399498521280596,
                "Title": "浦东新区国家发改委",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:07:37.583",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:33.167",
                "Sequence": 110,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399498621944027,
                "Title": "武汉市青山区科学技术局",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:07:43.493",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:36.063",
                "Sequence": 120,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399498705830007,
                "Title": "浦东新区科经委",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:07:48.7",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:37.287",
                "Sequence": 130,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399498806493385,
                "Title": "周家渡街道",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:07:54.417",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:41.357",
                "Sequence": 140,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399498907156587,
                "Title": "......",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:08:00.577",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:44.107",
                "Sequence": 500,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            }
        ],
        "ImgUrl": "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/Assets/Images/nopic.jpg"
    }
]

export namespace ClassicCase {

    export interface IProps<S extends IState = IState> extends ViewComponent.IProps<S> { }

    export interface IState extends ViewComponent.IState, classiccaseModel.StateType { }

    export class Component<P extends IProps = IProps, S extends IState = IState> extends ViewComponent.Base<P, S> {
        showloading = false;
        namespace = Namespaces.classiccase;

        componentMount() {
            window.scroll(0, 0);
            setLocalStorage("selectedMenu", `/classiccase`);
        }
        componentDidMount() {
            this.dispatch("input", { introIndex: 0, poleSlides: 4, poleSpace: 24, tabsSpace: 20 })
            this.dispatch("input", {
                clientIndex: "zonghkfq",
                choseList: clientData[0].chileList
            });

            this.scalePage();
            $(window).resize(() => {
                return this.scalePage();
            });

            r2040ArticleService.getPaged({
                pageSize: 9999, inTagIds: [
                    EnumGroupHomeTag.hezal
                ], isValid: true, orderBy: 'isTop,sequence,id desc'
            }).then(d => {
                this.dispatch("input", { hezal: d.items });
            });
        }

        scalePage() {
            const width = document.documentElement.clientWidth;
            if (width < 770) {
                this.dispatch("input", { poleSlides: 2, poleSpace: 16, tabsSpace: 10 });
            } else {
                this.dispatch("input", { poleSlides: 4, poleSpace: 24, tabsSpace: 20 });
            }
        }

        changeTabs(i) {
            this.dispatch("input", { introIndex: i })
        }


        renderService() {
            const { state } = this.props,
                introIndex = state!.introIndex || 0,
                tabsSpace = state!.tabsSpace,
                hezal = state!.hezal;
            if (!hezal?.length)
                return <Loading.Component></Loading.Component>;
            const data = hezal[introIndex];

            return (
                <div className="block-content al-introduce-content">
                    <div className="second-title">
                        <span>合作案例</span>
                    </div>
                    <Swiper
                        className="tabs-swiper"
                        style={{ height: 120 }}
                        loop={true}
                        centeredSlides={true}
                        slidesPerView={"auto"}
                        slideToClickedSlide={true}
                        spaceBetween={tabsSpace}
                        onSlideChange={(e) => {
                            e.slides.map((item) => {
                                item.classList.remove("opacity4")
                            })
                            e.slides.eq(e.activeIndex-3).addClass("opacity4")
                            e.slides.eq(e.activeIndex-4).addClass("opacity4")
                            // this.dispatch("input", {tabsSwiper: e})
                        }}
                    >
                        {hezal.map((item, i) => {
                          return (
                              <SwiperSlide key={i}>
                                  <div
                                      className={introIndex === i ? "introduce-nav-item active" : "introduce-nav-item"}
                                      onClick={() => this.changeTabs(i)}
                                  >
                                      <img src={transformAssetsUrl(item.logo)} />
                                  </div>
                              </SwiperSlide>
                          )
                        })}
                    </Swiper>
                    <div className="container visible">
                        {/*<Row className="introduce-nav" gutter={{ xs: 8, sm: 16, md: 20 }}>
                            {hezal.map((item, i) => {
                                return (
                                    <Col span={5} key={i}>
                                        <div
                                            className={introIndex === i ? "introduce-nav-item active" : "introduce-nav-item"}
                                            onClick={() => this.dispatch("input", { introIndex: i })}
                                        >
                                            <img src={transformAssetsUrl(item.logo)} />
                                        </div>
                                    </Col>
                                )
                            })}
                        </Row>*/}
                        {
                            <>
                                <div className="introduce-write mt50">
                                    <div className="primary-color size-30 text-center">{data.title}</div>
                                    <div className="size-18 gray-one-color introduce-write-desc mt30">
                                        <HtmlContent.Component html={data.content} />
                                    </div>
                                    {/* <div className="size-24 gray-one-color text-center mt10">园区数字化+阿里云创新中心+产业招商</div>
                                    <div className="size-18 gray-one-color introduce-write-desc mt30">
                                        <p>作为上海首批未来产业先导区之一，张江科学城将在若干个细分产业领域发挥引领示范作用，在产业发展路径模式上、体制机制上、制度政策上探索创新，成为未来技术策源地、基础研究发源地。瑞谷凭借自身产业服务多年经验，和张江科学城在园区数字化、大企业创新中心和产业招商等领域开展了全方位深度合作。</p>
                                        <p>为张江科学城打造园区数字化综合管理服务平台，依托AI智能化算法赋能“智能发现、主动派单、管理闭环”体系，累计处理企业诉求900+个，服务36000+次，智能发现500+家潜力企业，为园区综合管理与服务打下坚实基础。</p>
                                        <p>同时，瑞谷推动张江科学城和阿里云强强联手，共同建设阿里云创新中心张江基地，并由瑞谷招商运营。六年来，张江基地聚焦于“云计算、大数据AIOT”等领域，累计引进200+优质项目，成功孵化30+高新技术企业，近10家企业估值过亿。</p>
                                    </div> */}
                                </div>
                                {data?.otherPicture?.length && <div className="classiccase-img">
                                        <ImageAuto.Component src={transformAssetsUrl(data?.otherPicture[0])} width="800px" height="470px" radius={0} />
                                    </div>
                                }
                                {/*{data?.otherPicture?.length && <div className="intro-swiper-box">
                                    <div className="swiper-button-prev" />
                                    <div className="swiper-button-next" />
                                    <Swiper
                                        className="intro-swiper"
                                        style={{ height: 560 }}
                                        navigation={{
                                            nextEl: '.intro-swiper-box .swiper-button-next',
                                            prevEl: '.intro-swiper-box .swiper-button-prev'
                                        }}
                                        pagination
                                        effect={"coverflow"}
                                        loop={true}
                                        centeredSlides={true}
                                        grabCursor={true}
                                        slidesPerView={"auto"}
                                        coverflowEffect={{
                                            rotate: 0,
                                            stretch: 60,
                                            depth: 500,
                                            modifier: 2,
                                            slideShadows: true
                                        }}
                                    >
                                        {data?.otherPicture.map((item, i) => {
                                            return (
                                                <SwiperSlide key={i}>
                                                    <div className="intro-swiper-img">
                                                        <ImageAuto.Component src={transformAssetsUrl(item)} width="100%" height="100%" radius={0} />
                                                    </div>
                                                </SwiperSlide>
                                            );
                                        })}
                                    </Swiper>
                                </div>}*/}
                            </>
                        }
                        {/* {
                            introIndex === 1 && <>
                                <div className="introduce-write mt50">
                                    <div className="primary-color size-30 text-center">金桥开发区</div>
                                    <div className="size-24 gray-one-color text-center mt10">智能网联汽车产创基地+产业招商</div>
                                    <div className="size-18 gray-one-color introduce-write-desc mt30">
                                        <p>近年来，拥有深厚汽车产业底蕴的金桥开发区持续聚焦新能源汽车和智能汽车发展，开发区紧抓产业转型升级发展机遇，与国际尖端产业资源引进合作，不断推动新一轮经济转型。</p>
                                        <p>金桥集团与瑞谷集团强强合作，牵手 落地上海首个以”互联网+汽车“产业为垂直孵化领域的创新中心，聚焦人工智能、5G+汽车应用、未来车、智能制造、车+互联网等科技创新技术，致力于推动汽车的“新四化”建设。</p>
                                        <p>上海金桥智能网联汽车产创基地以构建“互联网+汽车”产业创新生态为主线，链接“未来车、智能造、数据港”全产业。两年累计引进近200家优质项目，举办活动50余场，对接宝马PoC测试6家，培育高新技术企业6家。</p>
                                    </div>
                                </div>
                                <div className="intro-swiper-box">
                                    <div className="swiper-button-prev" />
                                    <div className="swiper-button-next" />
                                    <Swiper
                                        className="intro-swiper"
                                        style={{ height: 560 }}
                                        navigation={{
                                            nextEl: '.intro-swiper-box .swiper-button-next',
                                            prevEl: '.intro-swiper-box .swiper-button-prev'
                                        }}
                                        pagination
                                        effect={"coverflow"}
                                        loop={true}
                                        centeredSlides={true}
                                        grabCursor={true}
                                        slidesPerView={"auto"}
                                        coverflowEffect={{
                                            rotate: 0,
                                            stretch: 60,
                                            depth: 500,
                                            modifier: 2,
                                            slideShadows: true
                                        }}
                                    >
                                        {zyData2.map((item, i) => {
                                            return (
                                                <SwiperSlide key={i}>
                                                    <div className="intro-swiper-img">
                                                        <ImageAuto.Component src={item.imgUrl} width="100%" height="100%" radius={0} />
                                                    </div>
                                                </SwiperSlide>
                                            );
                                        })}
                                    </Swiper>
                                </div>
                            </>
                        }
                        {
                            introIndex === 2 && <>
                                <div className="introduce-write mt50">
                                    <div className="primary-color size-30 text-center">浙江丽水</div>
                                    <div className="size-24 gray-one-color text-center mt10">阿里云创新中心+蚂蚁链创新中心+委托招商+总部经济+飞地运营</div>
                                    <div className="size-18 gray-one-color introduce-write-desc mt30">
                                        <p>2022年，瑞谷为浙江丽水莲都、遂昌分别引入蚂蚁链产业创新中心和阿里云创新中心。瑞谷凭借丰富的产业招商经验，为丽水提供产业招商数字化解决方案，成立专属招商服务团队，助力丽水开展委托招商、总部经济和飞地运营业务，帮助政府解决招商实际问题。</p>
                                        <p>未来，瑞谷将结合丽水资源禀赋、产业定位、招商需求等，通过信息化技术服务、优质项目的引入、生态企业的落地和产业人才的培养，有效助力丽水打造区域级创新创业高地，进一步推动丽水经济跃上新能级。</p>
                                    </div>
                                </div>
                                <div className="intro-swiper-box">
                                    <div className="swiper-button-prev" />
                                    <div className="swiper-button-next" />
                                    <Swiper
                                        className="intro-swiper"
                                        style={{ height: 560 }}
                                        navigation={{
                                            nextEl: '.intro-swiper-box .swiper-button-next',
                                            prevEl: '.intro-swiper-box .swiper-button-prev'
                                        }}
                                        pagination
                                        effect={"coverflow"}
                                        loop={true}
                                        centeredSlides={true}
                                        grabCursor={true}
                                        slidesPerView={"auto"}
                                        coverflowEffect={{
                                            rotate: 0,
                                            stretch: 60,
                                            depth: 500,
                                            modifier: 2,
                                            slideShadows: true
                                        }}
                                    >
                                        {zyData3.map((item, i) => {
                                            return (
                                                <SwiperSlide key={i}>
                                                    <div className="intro-swiper-img">
                                                        <ImageAuto.Component src={item.imgUrl} width="100%" height="100%" radius={0} />
                                                    </div>
                                                </SwiperSlide>
                                            );
                                        })}
                                    </Swiper>
                                </div>
                            </>
                        }
                        {
                            introIndex === 3 && <>
                                <div className="introduce-write mt50">
                                    <div className="primary-color size-30 text-center">湖州南浔</div>
                                    <div className="size-24 gray-one-color text-center mt10">委托招商+飞地运营</div>
                                    <div className="size-18 gray-one-color introduce-write-desc mt30">
                                        <p>南浔隶属于浙江省湖州市，地处长三角沪苏杭中心，距上海、杭州、苏州100公里，构成
                                            1小时交通圈。今年以来，南浔以数字化引领全面深化改革，以数智赋能助推产业升级。
                                            举全区之力推进上合区建设，快速形成接轨上海火热态势；以“放管服”改革持续优化
                                            营商环境，入选全省首批“三位一体”改革示范区。</p>
                                        <p>瑞谷以多年委托招商、飞地运营经验及成熟运营体系，为南浔持续招引优质企业，并协
                                            助其在上海松江飞地进行产业招引。瑞谷将依据南浔产业发展“延链布局”，围绕“2+6+N”主导产业，积极开展产业链精准招商，匹配行业国内头部企业和重点配套企业，提升产业链核心竞争力，助力南浔产业发展，带动区域经济提升</p>
                                    </div>
                                </div>
                                <div className="intro-swiper-box">
                                    <div className="swiper-button-prev" />
                                    <div className="swiper-button-next" />
                                    <Swiper
                                        className="intro-swiper"
                                        style={{ height: 560 }}
                                        navigation={{
                                            nextEl: '.intro-swiper-box .swiper-button-next',
                                            prevEl: '.intro-swiper-box .swiper-button-prev'
                                        }}
                                        pagination
                                        effect={"coverflow"}
                                        loop={true}
                                        centeredSlides={true}
                                        grabCursor={true}
                                        slidesPerView={"auto"}
                                        coverflowEffect={{
                                            rotate: 0,
                                            stretch: 60,
                                            depth: 500,
                                            modifier: 2,
                                            slideShadows: true
                                        }}
                                    >
                                        {zyData4.map((item, i) => {
                                            return (
                                                <SwiperSlide key={i}>
                                                    <div className="intro-swiper-img">
                                                        <ImageAuto.Component src={item.imgUrl} width="100%" height="100%" radius={0} />
                                                    </div>
                                                </SwiperSlide>
                                            );
                                        })}
                                    </Swiper>
                                </div>
                            </>
                        }
                        {
                            introIndex === 4 && <>
                                <div className="introduce-write mt50">
                                    <div className="primary-color size-30 text-center">临港集团</div>
                                    <div className="size-24 gray-one-color text-center mt10">“临港云”业管一体化平台</div>
                                    <div className="size-18 gray-one-color introduce-write-desc mt30">
                                        <p>临港集团通过综合开发区(2)+科技产业园区(4)+科创园区(3)+合作拓展园区(X)的总体发展格局，开发运营了包括临港产业区、漕河泾开发区、临港科技城等在内的50多家园区，占地面积达134平方公里，汇聚11000余家企业，44多万员工。</p>
                                        <p>为适应新时代的发展需要，临港集团以建设“数字临港”为目标，以提高管理效能，提升业务产能”为准绳，以业务规范化、流程标准化、管理透明化、招商精准化、运营高效化、服务体系化和决策科学化为方向的临港集团数字化转型总体蓝图已经绘就，率先建设“临港云”业管一体化平台。</p>
                                        <p>目前，“临港云”业管一体化平台已正式上线，在完成按照试点、完善、标准化、全覆盖的既定目标后，正从试点园区向上市板块、新片区及所有平台公司复制推广，从而加快推进“数字临港”建设，进一步实现临港集团实体经济与数字经济融合发展。</p>
                                    </div>
                                </div>
                                <div className="intro-swiper-box">
                                    <div className="swiper-button-prev" />
                                    <div className="swiper-button-next" />
                                    <Swiper
                                        className="intro-swiper"
                                        style={{ height: 560 }}
                                        navigation={{
                                            nextEl: '.intro-swiper-box .swiper-button-next',
                                            prevEl: '.intro-swiper-box .swiper-button-prev'
                                        }}
                                        pagination
                                        effect={"coverflow"}
                                        loop={true}
                                        centeredSlides={true}
                                        grabCursor={true}
                                        slidesPerView={"auto"}
                                        coverflowEffect={{
                                            rotate: 0,
                                            stretch: 60,
                                            depth: 500,
                                            modifier: 2,
                                            slideShadows: true
                                        }}
                                    >
                                        {zyData5.map((item, i) => {
                                            return (
                                                <SwiperSlide key={i}>
                                                    <div className="intro-swiper-img">
                                                        <ImageAuto.Component src={item.imgUrl} width="100%" height="100%" radius={0} />
                                                    </div>
                                                </SwiperSlide>
                                            );
                                        })}
                                    </Swiper>
                                </div>
                            </>
                        }
                        {
                            introIndex === 5 && <>
                                <div className="introduce-write mt50">
                                    <div className="primary-color size-30 text-center">世博地区</div>
                                    <div className="size-24 gray-one-color text-center mt10">经济数字化（挂图作战）平台</div>
                                    <div className="size-18 gray-one-color introduce-write-desc mt30">
                                        <p>世博地区区域面积约25平方公里，包含世博园区浦东地块、耀华地块、前滩地块、南码头、周家渡、上钢新村、东明路街道，现有企业约2万家，着重打造世界级城市中央公共活动区。</p>
                                        <p>上海自贸试验区世博区域经济数字化（挂图作战）平台，以大数据技术+创新治理体系赋能科学决策，打造政府治理能力先行区。管理局领导统筹化管控产业招商；通过精准服务促进企业发展，并对服务效能实时监控分析；实现世博区域经济治理的精细化、动态化和即时化。</p>
                                        <p>自动采集与实时监控世博区域约2万家企业的500+项数据字段；累计监测9000+次风险记录，1600+家风险企业；智能发现70+家潜力企业、200+家纳税异动企业；帮助世博地区40+名服务专员，精准服务于120+家重点企业。</p>
                                    </div>
                                </div>
                            </>
                        }
                        {
                            introIndex === 6 && <>
                                <div className="introduce-write mt50">
                                    <div className="primary-color size-30 text-center">四川成都</div>
                                    <div className="size-24 gray-one-color text-center mt10">宝马初创车库-阿里云创新中心智能汽车产业创新基地</div>
                                    <div className="size-18 gray-one-color introduce-write-desc mt30">
                                        <p>宝马初创车库—阿里云创新中心（成都高新）智能汽车产业创新基地打造“互联网+汽车”赛道从初创期到成熟期的阶梯式、全产业链生态圈。</p>
                                        <p>基地由宝马集团与阿里巴巴集团强强合作，牵手瑞谷科创运营落地。各方充分共享各自的优势资源，开展“互联网+汽车”项目引进与培育创新、特色品牌传播与活动运营、金融支持、宝马与阿里云生态技术资源导入与加速服务等。</p>
                                        <p>基地运营一年，已累计触达1000多家企业，对接宝马PoC测试4家，入驻企业16家，举办活动超10场，培育高新技术企业7家。</p>
                                    </div>
                                </div>
                            </>
                        }
                        {
                            introIndex === 7 && <>
                                <div className="introduce-write mt50">
                                    <div className="primary-color size-30 text-center">杭州西溪谷</div>
                                    <div className="size-24 gray-one-color text-center mt10">杭州蚂蚁链产业创新中心</div>
                                    <div className="size-18 gray-one-color introduce-write-desc mt30">
                                        <p>杭州蚂蚁链产业创新中心，是西湖区政府基于西溪谷的产业优势和蚂蚁集团的区块链技术打造的以“互联网+区块链+人工智能”等数字经济聚合为导向的创新产业园区，致力于打造成全国范围内旗舰型的示范基地；通过提供“政策+平台+技术+人才+资本”的全方位配套服务，搭建数字经济产学研一体化平台，打开区块链产业发展应用的窗口，助推杭州西湖区的区块链产业集群建设。</p>
                                        <p>2023年度，杭州蚂蚁链产业创新中心，成功获评2023年度杭州市级 专业化科技企业孵化器！全年孵化8家企业获得 “浙江省科技中小型企业”称号，2家企业新获“国家高新技术企业”认定。</p>
                                    </div>
                                </div>
                                <div className="intro-swiper-box">
                                    <div className="swiper-button-prev" />
                                    <div className="swiper-button-next" />
                                    <Swiper
                                        className="intro-swiper"
                                        style={{ height: 560 }}
                                        navigation={{
                                            nextEl: '.intro-swiper-box .swiper-button-next',
                                            prevEl: '.intro-swiper-box .swiper-button-prev'
                                        }}
                                        pagination
                                        effect={"coverflow"}
                                        loop={true}
                                        centeredSlides={true}
                                        grabCursor={true}
                                        slidesPerView={"auto"}
                                        coverflowEffect={{
                                            rotate: 0,
                                            stretch: 60,
                                            depth: 500,
                                            modifier: 2,
                                            slideShadows: true
                                        }}
                                    >
                                        {myData.map((item, i) => {
                                            return (
                                                <SwiperSlide key={i}>
                                                    <div className="intro-swiper-img">
                                                        <ImageAuto.Component src={item.imgUrl} width="100%" height="100%" radius={0} />
                                                    </div>
                                                </SwiperSlide>
                                            );
                                        })}
                                    </Swiper>
                                </div>
                            </>
                        }
                        {
                            introIndex === 8 && <>
                                <div className="introduce-write mt50">
                                    <div className="primary-color size-30 text-center">南通如东</div>
                                    <div className="size-24 gray-one-color text-center mt10">产业招商深度合作</div>
                                    <div className="size-18 gray-one-color introduce-write-desc mt30">
                                        <p>南通如东位于华东地区、江苏东南部、长江口北岸，属于长三角核心经济圈、上海“1+6”都市圈叠加覆盖区。近年来，如东实现了“经济总量连年跨百亿、财政收入实现首赶超、项目建设持续扛红旗、百强排名快速向前移”等一系列突破。2022年，全县实现地区生产总值1314亿元，一般公共预算收入76.9亿元，综合实力上升至全国百强县（市）第31位。</p>
                                        <p>如东已形成了4个各具特色、优势互补、功能完备的沿海产业园区：如东洋口港经济开发区、如东经济开发区、洋口镇（沿海经济开发区）和掘港镇（如东高新区）。依托四大主功能区已形成的产业特色拓展延展，积极打造新能源、新材料、泛半导体、生命健康、安全防护、食品等“6+N”产业链。</p>
                                        <p>瑞谷云企与如东长期深度合作，通过大数据算法为如东筛选主导产业上下游的高潜力优质企业，定向招商强链补链延链。合作至今，瑞谷云企已为如东推荐了百余个项目，实地对接考察30余个，落地签约6个。</p>
                                    </div>
                                </div>
                            </>
                        }
                        {
                            introIndex === 9 && <>
                                <div className="introduce-write mt50">
                                    <div className="primary-color size-30 text-center">镇江市商务局</div>
                                    <div className="size-24 gray-one-color text-center mt10">产业招商深度合作</div>
                                    <div className="size-18 gray-one-color introduce-write-desc mt30">
                                        <p>镇江市位于长江与京杭大运河“十”字交汇处，这里有山有水有故事，城市清新秀丽、人文荟萃、交通便捷、产业发达，是长三角地区重要的港口、工贸和风景旅游城市。先后获得全国文明城市、国家历史文化名城、全国科技进步先进城市、全国双拥模范城市等多个国家级荣誉称号。总面积3840平方公里，常住人口322万，辖丹阳、句容、扬中3个县级市，丹徒、京口、润州3个区和镇江新区、镇江高新区2个国家级开发区。</p>
                                        <p>镇江关注重视高质量、高端化、大规模、大牵引的项目，同时也密切跟踪有利于传统产业优化升级、战略性新兴产业倍增和新经济新动能培育的小而美、小而精的项目。</p>
                                        <p>瑞谷云企将根据镇江招商引资需求，瞄准高端装备制造、生命健康、新材料和数字经济等四大产业集群，和新型电力（新能源）装备、汽车及零部件（新能源汽车）、高性能材料、医疗器械和生物医药、新一代信息技术、航空航天、船舶海工装备和智能农机设备等八条重点产业链，为镇江持续招引高质量项目，为镇江招商引资提质增速。</p>
                                    </div>
                                </div>
                                <div className="intro-swiper-box">
                                    <div className="swiper-button-prev" />
                                    <div className="swiper-button-next" />
                                    <Swiper
                                        className="intro-swiper"
                                        style={{ height: 560 }}
                                        navigation={{
                                            nextEl: '.intro-swiper-box .swiper-button-next',
                                            prevEl: '.intro-swiper-box .swiper-button-prev'
                                        }}
                                        pagination
                                        effect={"coverflow"}
                                        loop={true}
                                        centeredSlides={true}
                                        grabCursor={true}
                                        slidesPerView={"auto"}
                                        coverflowEffect={{
                                            rotate: 0,
                                            stretch: 60,
                                            depth: 500,
                                            modifier: 2,
                                            slideShadows: true
                                        }}
                                    >
                                        {zjData.map((item, i) => {
                                            return (
                                                <SwiperSlide key={i}>
                                                    <div className="intro-swiper-img">
                                                        <ImageAuto.Component src={item.imgUrl} width="100%" height="100%" radius={0} />
                                                    </div>
                                                </SwiperSlide>
                                            );
                                        })}
                                    </Swiper>
                                </div>
                            </>
                        } */}
                    </div>
                </div>
            )
        }


        renderSystem() {
            const introduceData = [
                "assets/images/guanw/biaog-logo1.png",
                "assets/images/guanw/biaog-logo2.png",
                "assets/images/guanw/biaog-logo3.png",
                "assets/images/guanw/biaog-logo4.png",
                "assets/images/guanw/biaog-logo5.png",
                "assets/images/guanw/biaog-logo6.png",
                "assets/images/guanw/biaog-logo7.png",
                "assets/images/guanw/biaog-logo8.png",
                "assets/images/guanw/biaog-logo9.png",
                "assets/images/guanw/biaog-logo10.png",
                "assets/images/guanw/biaog-logo11.png",
                "assets/images/guanw/biaog-logo12.png",
                "assets/images/guanw/biaog-logo13.png",
                "assets/images/guanw/biaog-logo14.png",
                "assets/images/guanw/biaog-logo15.png",
                "assets/images/guanw/biaog-logo16.png",
                "assets/images/guanw/biaog-logo17.png",
                "assets/images/guanw/biaog-logo18.png",
                "assets/images/guanw/biaog-logo19.png",
                "assets/images/guanw/biaog-logo20.png",
                "assets/images/guanw/biaog-logo21.png",
                "assets/images/guanw/biaog-logo22.png",
                "assets/images/guanw/biaog-logo23.png",
                "assets/images/guanw/biaog-logo24.png",
                "assets/images/guanw/biaog-logo25.png",
                "assets/images/guanw/biaog-logo26.png",
                "assets/images/guanw/biaog-logo27.png",
                "assets/images/guanw/biaog-logo28.png",
                "assets/images/guanw/biaog-logo29.png",
                "assets/images/guanw/biaog-logo30.png"
            ]
            return (
                <div className="block-content biaog-content">
                    <div className="container" style={{overflow:"visible"}}>
                        <div className="second-title">
                            <span>标杆客户</span>
                        </div>
                        <Row className="introduce-nav" gutter={{xs: 8, sm: 16, md: 20}}>
                            {introduceData.map((item, i) => {
                                return (
                                    <Col span={5} key={i}>
                                        <div
                                            className={"introduce-nav-item"}
                                        >
                                            <img src={item} />
                                        </div>
                                    </Col>
                                )
                            })}
                        </Row>
                    </div>
                </div>
            )
        }


        renderCompany() {
            const {state} = this.props,
                clientIndex = state!.clientIndex,
                choseList = state!.choseList;
            return (
                <div className="block-content">
                    <div className="container" style={{overflow:"visible"}}>
                        <div className="second-title">
                            <span>其他客户</span>
                        </div>
                        <div className="client-tabs">
                            {
                                clientData && clientData.map((item, i) => {
                                    return (
                                        <span
                                            key={i}
                                            className={clientIndex === item.CatalogCode ? "active" : ""}
                                            onClick={() => this.dispatch("input", {clientIndex: item.CatalogCode, choseList: item.chileList})}
                                        >
                                            {item.CatalogName}
                                        </span>
                                    )
                                })
                            }
                        </div>
                        <Row gutter={[20,20]} className="mt30 client-other">
                            {
                                choseList && choseList.map((item, i) => {
                                    return (
                                        <Col xs={12} sm={12} md={12} xl={8} key={i}>
                                            <div className="client-item">
                                                <span>{item.Title}</span>
                                                <i className="border1" />
                                                <i className="border2" />
                                                <i className="border3" />
                                                <i className="border4" />
                                            </div>
                                        </Col>
                                    )
                                })
                            }
                        </Row>
                    </div>
                </div>
            )
        }

        renderBody() {
            return (
                <>
                    <div className="content">
                        <Banner.Component extraClass="large" bimg="assets/images/guanw/hzal-banner.jpg" cimg="" text={
                            <div className="home-banner-text">
                                <div className="banner-text-name1">客户案例</div>
                                <div className="banner-text-name2 mt25">
                                    以科技创新赋能园区产业发展
                                </div>
                            </div>}
                        />
                        {this.renderService()}
                        {this.renderSystem()}
                        {this.renderCompany()}

                        {this.renderEmbeddedView(BackTopBox.Page)}
                    </div>
                </>
            );
        }
    }

    export const Page = template(Component, (state) => state[Namespaces.classiccase]);
}
